export const serverUrl = "http://127.0.0.1:8000";
export const currentDevUser = 709420289;

/** npm start → development, npm run build → production */
const isDevelopment = process.env.NODE_ENV === "development";

export const getAppUserId = (): number =>
  isDevelopment ? currentDevUser : 0;

export const getAppUserName = (): string =>
  isDevelopment ? "dev" : "guest";

/** Базовый URL API: в prod — текущий домен (kudavgorod.ru). */
export const getApiBaseUrl = (): string => {
  if (isDevelopment) {
    return serverUrl;
  }

  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "https://kudavgorod.ru";
};
